import { useState } from "react";
import { useParams } from "react-router-dom";
import { Search, SlidersHorizontal } from "lucide-react";
import MachineCard from "../components/modules/machines/MachineCard";
import machinesData from "../data/machinesData";

const categories = ["All", "3D Printing", "CNC", "Laser Cutting", "PCB", "Moulding", "Robotics"];

export default function Machines() {
  const { city } = useParams(); // present only when navigated from a specific facility
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("All");

  const filtered = machinesData.filter((m) => {
    const matchesCity = city ? m.centre.toLowerCase() === city.toLowerCase() : true;
    const matchesCategory = category === "All" || m.technology === category;
    const matchesQuery =
      m.name.toLowerCase().includes(query.toLowerCase()) ||
      m.technology.toLowerCase().includes(query.toLowerCase()) ||
      m.make.toLowerCase().includes(query.toLowerCase());
    return matchesCity && matchesCategory && matchesQuery;
  });

  return (
    <div>
      {/* Header */}
      <div className="bg-gradient-to-br from-[#1e1b4b] via-[#312e81] to-[#4c1d95] text-white rounded-2xl px-8 py-10 mb-6">
        <span className="inline-block text-xs font-semibold bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-4">
          {city ? `APIC ${city}` : "Machine Marketplace"}
        </span>
        <h1 className="text-3xl md:text-4xl font-extrabold mb-2">
          {city ? `Machines at APIC ${city}` : "340+ Machines. One platform."}
        </h1>
        <p className="text-indigo-100">
          Book industrial 3D printers, CNC machines, laser cutters, PCB
          prototypers and more.
        </p>
      </div>

      {/* Search + filters */}
      <div className="bg-white border border-gray-100 rounded-2xl p-3 flex flex-wrap items-center gap-3 mb-6">
        <div className="flex items-center flex-1 min-w-[220px] gap-2 px-3">
          <Search className="w-4 h-4 text-gray-400" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search machine, technology or make..."
            className="w-full py-2.5 text-sm focus:outline-none"
          />
        </div>
        <button
          type="button"
          className="flex items-center gap-2 border border-gray-200 rounded-xl px-4 py-2.5 text-sm font-medium hover:bg-gray-50"
        >
          <SlidersHorizontal className="w-4 h-4" />
          Filters
        </button>
      </div>

      {/* Category chips */}
      <div className="flex flex-wrap gap-2 mb-6">
        {categories.map((cat) => {
          const isActive = category === cat;
          return (
            <button
              key={cat}
              type="button"
              onClick={() => setCategory(cat)}
              className={`text-sm font-medium px-4 py-2 rounded-full border transition ${
                isActive
                  ? "bg-indigo-600 border-indigo-600 text-white"
                  : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
              }`}
            >
              {cat}
            </button>
          );
        })}
      </div>

      {/* Machine grid */}
      {filtered.length > 0 ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((machine) => (
            <MachineCard key={machine.code} machine={machine} />
          ))}
        </div>
      ) : (
        <div className="h-48 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
          No machines found.
        </div>
      )}
    </div>
  );
}